var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "#1E1E1E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ajouter entreprise",
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1512,
    height: 982,
    transform: "translate(-626 -428)",
    fill: "#131311"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Table"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tables"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 427319654"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Table_2"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_0_1)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 4013",
    filter: "url(#filter0_b_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -627,
    y: -429,
    width: 1515,
    height: 984,
    fill: "black",
    fillOpacity: 0.42
  })), /*#__PURE__*/React.createElement("g", {
    id: "Login",
    clipPath: "url(#clip2_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 567,
    transform: "translate(-57 -220)",
    fill: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 427319684"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 427319680"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4014",
    x: -23,
    y: -14,
    width: 308,
    height: 45,
    rx: 5,
    fill: "#232323"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.2,
    d: "M13.7458 11.2397C13.6365 12.0561 13.2345 12.805 12.6145 13.3471C11.9945 13.8893 11.1986 14.1878 10.375 14.1872C7.83887 14.1872 5.40661 13.1797 3.61329 11.3864C1.81998 9.5931 0.812501 7.16084 0.812501 4.62471C0.811871 3.80107 1.1104 3.00524 1.65257 2.38521C2.19474 1.76518 2.94364 1.36317 3.76 1.25393C3.88068 1.23959 4.00276 1.26472 4.10796 1.32556C4.21316 1.3864 4.29583 1.47968 4.3436 1.59143L5.8293 4.91018C5.8658 4.99542 5.88067 5.08836 5.87257 5.18073C5.86447 5.2731 5.83367 5.36204 5.78289 5.43963L4.28031 7.22627C4.22701 7.3067 4.1955 7.39958 4.18884 7.49583C4.18219 7.59208 4.20062 7.68842 4.24234 7.77541C4.82383 8.9658 6.0543 10.1815 7.2482 10.7574C7.33566 10.7989 7.43243 10.8169 7.52898 10.8097C7.62553 10.8024 7.71851 10.7701 7.79875 10.7159L9.55656 9.21823C9.63446 9.16639 9.72406 9.1348 9.81725 9.12633C9.91044 9.11786 10.0043 9.13277 10.0902 9.16971L13.4062 10.6554C13.5184 10.7029 13.6123 10.7855 13.6735 10.8909C13.7348 10.9963 13.7601 11.1187 13.7458 11.2397Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.6354 10.1416L10.323 8.65728L10.3138 8.65306C10.1419 8.57951 9.95429 8.54999 9.76805 8.56718C9.58181 8.58437 9.40279 8.64772 9.24719 8.7515C9.22886 8.76358 9.21126 8.77673 9.19446 8.79087L7.48305 10.2499C6.39883 9.72322 5.27946 8.61228 4.75282 7.54212L6.21391 5.8047C6.22798 5.78712 6.24133 5.76955 6.25399 5.75056C6.35554 5.59538 6.41716 5.41751 6.43335 5.23276C6.44954 5.04802 6.41981 4.86213 6.3468 4.69165V4.68322L4.85829 1.36517C4.76178 1.14247 4.59583 0.956946 4.38522 0.836307C4.1746 0.715667 3.93062 0.666377 3.68969 0.695795C2.73694 0.821167 1.8624 1.28907 1.22941 2.01211C0.596427 2.73515 0.248284 3.66389 0.250006 4.62486C0.250006 10.2077 4.79219 14.7499 10.375 14.7499C11.336 14.7516 12.2647 14.4034 12.9878 13.7705C13.7108 13.1375 14.1787 12.2629 14.3041 11.3102C14.3335 11.0693 14.2844 10.8254 14.1638 10.6148C14.0433 10.4042 13.858 10.2382 13.6354 10.1416ZM10.375 13.6249C7.98886 13.6223 5.70119 12.6732 4.01392 10.9859C2.32666 9.29868 1.37761 7.01101 1.37501 4.62486C1.37236 3.93825 1.61973 3.27415 2.07091 2.75659C2.5221 2.23903 3.14625 1.90339 3.8268 1.81236C3.82652 1.81516 3.82652 1.81799 3.8268 1.8208L5.30337 5.12548L3.85001 6.86501C3.83523 6.88196 3.82182 6.90007 3.80993 6.91915C3.70412 7.08152 3.64205 7.26846 3.62973 7.46187C3.61741 7.65528 3.65526 7.84858 3.73962 8.02306C4.37665 9.32595 5.68938 10.6288 7.00633 11.2652C7.18209 11.3487 7.37652 11.3853 7.57062 11.3712C7.76473 11.3572 7.95187 11.293 8.11376 11.185C8.13185 11.1729 8.14922 11.1598 8.16579 11.1456L9.87508 9.68736L13.1798 11.1674H13.1875C13.0976 11.8489 12.7624 12.4744 12.2448 12.9267C11.7271 13.379 11.0624 13.6272 10.375 13.6249Z",
    fill: "#939393"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_0_1",
    x: -637,
    y: -439,
    width: 1535,
    height: 1004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1512,
    height: 982,
    fill: "white",
    transform: "translate(-626 -428)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_0_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-121 -55H38V243H-121V-55Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 567,
    fill: "white",
    transform: "translate(-57 -220)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTel);
export default __webpack_public_path__ + "static/media/tel.2d80ba579c1e827159ba097f70d3a374.svg";
export { ForwardRef as ReactComponent };